import React from 'react';
import PropTypes from 'prop-types';
import { autobind } from 'core-decorators';
import BaseDialog from 'components/BaseDialog';
import styledComp, { FlexColContainer } from 'components/StyledComp';

const propTypes = {
  ediText: PropTypes.string.isRequired,
};

@autobind
class EdiTextDialog extends BaseDialog {
  constructor(props) {
    super(props);
  }

  render() {
    const { ediText, isVisible, ...layoutProps } = this.props;

    return (
      <styledComp.AntdModal
        {...layoutProps}
        // maxWidth="700px"
        style={{ top: 20 }}
        // bodyStyle={{ padding: '0 0' }}
        visible={isVisible}
        maskClosable
        afterClose={this.onModalHide}
        onOk={this.onOkClick}
        onCancel={this.onOkClick}
      >
        <FlexColContainer
          width="match_parent"
          height="wrap_content"
        >
          <styledComp.AntdInputTextArea
            width="match_parent"
            height="wrap_content"
            rows={30}
            value={ediText}
          />
        </FlexColContainer>
      </styledComp.AntdModal>
    );
  }
}

// https://facebook.github.io/react/docs/typechecking-with-proptypes.html
EdiTextDialog.propTypes = propTypes;

export default EdiTextDialog;
